import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { initSentry } from './config/sentry';
import * as Sentry from '@sentry/react';
import { isProduction } from './utils/envUtils';
import { ThemeProvider } from './contexts';

initSentry();

const root = createRoot(document.getElementById('root')!);

const AppContent = () => (
  <ThemeProvider defaultMode="system">
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster position="top-right" />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);

const RootComponent = () => {
  if (isProduction() && import.meta.env.VITE_SENTRY_DSN) {
    return (
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Something went wrong</h1>
            <p>We've been notified and are working on a fix.</p>
            <button onClick={resetError}>Try again</button>
          </div>
        )}
        showDialog
      >
        <AppContent />
      </Sentry.ErrorBoundary>
    );
  }

  return <AppContent />;
};

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

reportWebVitals();
